module.exports = __webpack_public_path__ + "img/no_data_infographic.86f44b8f.svg";